import React, {Fragment, useState, useRef, useEffect} from 'react';

import { Globals, displayAlert } from '../globals' ;
import $ from "jquery";
import {checkError, handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";

import ModalPrivacyStatement from "../ModalPrivacyStatement";
import Modal from "react-responsive-modal";
import {fromBase64} from "js-base64";
import {doRegister, doPasswordReset, submitChangePassword} from "root/DataFunctions/LoginFns";
import LoginNewUserRegistrationForm from "root/LoginNewUserRegistrationForm";
import VanillaModal from "root/Modals/VanillaModal/VanillaModal";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";

import {useForm} from "react-hook-form";
import {FormInputPassword} from "root/ReactHookForm/FormComponents";
import {LoginRouteMaps} from "@root/Login/LoginRouteMaps";

import './LoginPage.scss' ;
import FormFragmentLoginInputs from "root/Login/FormFragmentLoginInputs";
import {ProviderVariantType} from "root/Common/Constants/ProviderVariantType";
import {defaultRules} from "root/ReactHookForm/FormComponents/FormInputPassword";

const LoginForm = ({params, redirect, logoutreason = undefined, authority_id, variant_type= 1, title, reason, username, token, useProvider = true, suppressLogo = false, mode='login', defaultLogo = '/style/images/seven360/ncc_logo.png', ...props}) =>
{
	const initialUserName = () =>
	{
		if ( mode === 'activate' )
		{
			return fromBase64(username) ;
		}
		else if ( mode === 'password_reset_complete')
		{
			return username ;
		}
		else
		{
			return null ;
		}
	}

	const {
		register,
		handleSubmit,
		setFocus,
		setError,
		formState: {errors: formErrors}
	} = useForm(
		{
			defaultValues: {
				login: {
					establishment_number: null,
					username: initialUserName(),
					password: null,
					password1: null,
					oldpassword: null,
				}
			}
		});

	const [ currentMode, setCurrentMode ] = useState ( mode === '' || mode === null || mode === undefined ? 'login' : mode ) ;
	const [ user_type, setUserType ] = useState ( props.user_type ) ;
	const [ user_id, setUserId ] = useState ( props.user_id ) ;
	const [ user, setUser ] = useState ( [] ) ;

	const newUserForm = useRef(null);

	const [ dialogPrivacyOpen, setDialogPrivacyOpen ] = useState (false);

	useEffect(() => {
		setFocus('login.username')
	}, [setFocus]);

	const getHomePage = ( routeDescriptor, homepage ) =>
	{
		if ( homepage === undefined || homepage === null )
		{
			return routeDescriptor.homepage.default ;
		}
		else
		{
			return routeDescriptor.homepage[homepage] === undefined ? routeDescriptor.homepage.default :  routeDescriptor.homepage[homepage] ;
		}
	}

	const getRouting = ( user_type, homepage ) =>
	{
		const res = LoginRouteMaps.find((value, index) => {
			// Delete element 5 on first iteration
			return value.user_type === user_type ;
		});

		if ( res === undefined )
		{
			return undefined ;
		}
		else
		{
			if ( res.allow_redirect === true )
			{
				if ( redirect === undefined )
				{
					return getHomePage ( res, homepage ) ;
				}
				else
				{
					return redirect.length !== 0 ? redirect : getHomePage ( res, homepage ) ;	 ;
				}
			}
			else
			{
				return getHomePage ( res, homepage ) ;
			}
		}
	}

	const redirectKnownUserType = ( user_type, homepage = 'passport' ) =>
	{
		const p = getRouting( +user_type, homepage ) ;

		if ( p === undefined )
		{
			displayAlert({title: "Error", message: "Invalid User Type - please contact your system administrator"});
		}
		else
		{
			window.location.replace(p);
		}
	}
	
	const doPasswordResetConfirmation = ( user ) =>
	{
		const myModal = new VanillaModal({
			title: "Password Reset Accepted",
			width: '500px',
			content: "You have successfully requested a password reset. Please check your email for confirmation and further instructions.",
			buttons: VanillaModal.buttons.alert,
		}).show().once('dismiss', function(modal, ev, button) {
			if (button && button.value) {
				setCurrentMode ('login' ) ;
			}
		});
	}

	const doLoginFunctions = ( user ) =>
	{
        const user_type = user.user_type_id;
        const userid = user.user_id;
		const home_page = user.home_page ;
        
		if ( +(user.password_change_required) === 1 )
		{
			const myModal = new VanillaModal({
				title: "Successful Login",
				width: '500px',
				content: "You have successfully logged in but you must now change your password before continuing.",
				buttons: VanillaModal.buttons.alert,
			}).show().once('dismiss', function(modal, ev, button) {
				if (button && button.value)
				{
					setCurrentMode ('change_password_first') ;
					setUserType(user_type);
					setUserId (userid) ;
				}
			});
		}
		else
		{
            redirectKnownUserType ( user_type, home_page ) ;
		}
	}

	const doChangePassword = ( userid, newpass ) =>
	{
		submitChangePassword( userid, newpass, (response) =>
		{
			redirectKnownUserType ( user_type )
		})
	}
	
	const doChangeCurrentUserPassword = ( oldpass, newpass ) =>
	{
		const url = Globals.APIFolder + '/changepassword' ;

		let data = { oldpassword: oldpass, password: newpass } ;
		
        $.ajax({
            type: 'PUT',
            url: url ,
            data: { data },
            success:(data)=>{

    			if ( checkError(data))
				{
					const myModal = new VanillaModal({
						title: "Password change successful",
						width: '500px',
						content: "<p>Your password has now been changed.</p><p>If you have a School360 EYFS account, that password has also been changed.</p>",
						buttons: VanillaModal.buttons.alert,
					}).show().once('dismiss', function(modal, ev, button) {
						if (button && button.value)
						{
							setCurrentMode('password_changed') ;
						}
					});
				}

            },
            error:(jqXHR, textStatus, error)=>
            {
				handleAjaxError ( jqXHR, textStatus, error) ;    		  	
            }
        });
	}

	const doLogin = ( username, password, establishment ) =>
	{
		const url = Globals.APIFolder + "/login" ;
		
    	$.ajax({
    		  type: 'POST',
    		  url: url,
    		  data: { inpUsername: username, inpPassword: password, inpEstablishmentNumber: establishment },
    		  success:(data)=>
    		  {
    		  	if ( checkError(data))
				{
					const return_data = data.data[0] ;

					if ( return_data.login_result == 'success')
					{
						var user = data.data[0] ;

						if ( user.privacy_statement_read_date == null )
						{
							setCurrentMode ('privacy_statement') ;
							setUser(user) ;
							setDialogPrivacyOpen (true);
						}
						else
						{
							doLoginFunctions( user );
						}
					}
					else
					{
						if (return_data.reason === "invalid")
						{
							const myModal = new VanillaModal({
								title: "Login Failed",
								width: '500px',
								content: "<p>The credentials you entered are invalid. Please try again.</p>",
								buttons: VanillaModal.buttons.alert,
							}).show().once('dismiss', function(modal, ev, button) {
								if (button && button.value)
								{
									setCurrentMode ('login');
								}
							});
						}
						else if (return_data.reason === "inactive")
						{
							const myModal = new VanillaModal({
								title: "Login Failed",
								width: '500px',
								content: "<p>The account has not yet been activated.</p><p>Please check your email for an activation email or contact your system administrator.</p>",
								buttons: VanillaModal.buttons.alert,
							}).show().once('dismiss', function(modal, ev, button) {
								if (button && button.value)
								{
									setCurrentMode ('login');
								}
							});
						}
						else if (return_data.reason === "suspended")
						{
							const myModal = new VanillaModal({
								title: "Login Failed",
								width: '500px',
								content: "<p>The account has been suspended. Please contact your system administrator.</p>",
								buttons: VanillaModal.buttons.alert,
							}).show().once('dismiss', function(modal, ev, button) {
								if (button && button.value)
								{
									setCurrentMode ('login');
								}
							});
						}
					}
				}
    		  },
    		  error:(jqXHR, textStatus, error)=>
    		  {
					handleAjaxError ( jqXHR, textStatus, error) ;    		  	
		  	  }

    		});
	}

	const doResetPasswordSet = ( newpass ) =>
	{
		const url = Globals.APIFolder + '/resetpassword/set' ;

		const data = {
			password: newpass,
			token: token
		} ;

		$.ajax({
			type: 'POST',
			url: url ,
			data: data,
			success:(data)=>
			{
				if ( checkError(data))
				{
					setCurrentMode( 'password_reset_complete')
				}
			},
			error:(jqXHR, textStatus, error)=>
			{
				handleAjaxError ( jqXHR, textStatus, error) ;
			}
		});

	}

	const onForgotPassword = () =>
	{
		setCurrentMode ('forgot_password') ;
	}

	const onForgotPasswordCancel = () =>
	{
		setCurrentMode('login') ;
	}

	const onLogout = () =>
	{
		setCurrentMode('login') ;
	}

	const onChangePasswordCancel = () =>
	{
		setCurrentMode ('change_password') ;
	}

    const logo = ( image_path ) =>
    {
		let style = {} ;

		if ( authority_id === 'NCC')
		{
			if ( params.logo !== undefined )
			{
				style= { width: params.logoWidth, backgroundImage: `url(${params.logo}`} ;
			}
			else
			{
				style= { width: '100%',	 backgroundImage: `url(${image_path}`} ;
			}
		}
		else
		{
			const width = params.logoWidth === undefined ? '100%' : params.logoWidth;

			style= { width: width,	 backgroundImage: `url(${params.logo}`} ;
		}

        return (
			<div className='logo-line' style={style}>
			</div>
		)
    }
    
    const getTitle = ( title ) =>
    {
		if ( title !== undefined )
		{
	        return <h1>{title}</h1>
		}
		else if ( params?.subtitle !== undefined )
		{
			return <div style={params.subtitleStyle}>{params.subtitle}</div>
		}
    }

	const onSubmit = (formData) =>
	{
		if ( currentMode === 'login' || currentMode === 'password_reset_complete' || currentMode === 'activate')
		{
			const data = formData.login ;

			doLogin( data.username, data.password, data.establishment_number );
		}
		else if ( currentMode === 'forgot_password')
		{
			const data = formData.login ;

			doPasswordReset ( data.username, data.establishment_number, (response) =>
			{
				doPasswordResetConfirmation( );
			})
		}
		else if ( currentMode === 'password_reset')
		{
			const data = formData.login ;

			if ( data.password !== data.password1 )
			{
				const formError = { type: "validate", message: "Passwords must match" }
				setError('login.password1', formError)
			}
			else
			{
				doResetPasswordSet( data.password );
			}
		}
		else if ( currentMode === 'register')
		{
			const data = formData.login ;

			if ( data.password !== data.password1 )
			{
				const formError = { type: "validate", message: "Passwords must match" }
				setError('login.password1', formError)
			}
			else
			{
				doRegister(data.password, token,(response) =>
				{
					setCurrentMode ('register_complete') ;
				})
			}
		}
		else if ( currentMode === 'change_password_first')
		{
			const data = formData.login ;

			doChangePassword( user_id, data.password );
		}
		else if ( currentMode === 'change_password')
		{
			const data = formData.login ;

			if ( data.password !== data.password1 )
			{
				const formError = { type: "validate", message: "Passwords must match" }
				setError('login.password1', formError)
			}
			else
			{
				doChangeCurrentUserPassword(data.oldpassword, data.password );
			}
		}

	}

	const onClickSaveForm = (status) =>
	{
		handleSubmit(onSubmit)(status);
	}

	const infoHeader = () =>
	{
		if ( currentMode === 'activate' )
		{
			return (
				<Fragment>
					<p key='ac1'>Your account is now activated.</p>
					<p key='ac2'>Please enter your password below to log in.</p>
				</Fragment>
			)
		}

		if ( currentMode === 'password_reset_complete')
		{
			return (
				<Fragment>
					<p key='ac1'>Your password has been changed. If you have a School360 EYFS account, that password has also been changed.</p>
					<p key='ac2'>Please enter your new password below to log in.</p>
				</Fragment>
			)
		}

		if ( currentMode === 'forgot_password')
		{
			return (
				<Fragment>
					<p key='ac1' style={{textAlign: 'center'}}>Please enter your establishment number and username below to request a password reset.</p>
					<p key='ac2' style={{textAlign: 'center', color: 'red'}}>Please note your username is NOT your email address</p>
				</Fragment>
			)
		}

		if ( currentMode === 'login' && reason === 'inactive' )
		{
			return (
				<div key='ssowarning' className='sso-warning'>
					<p>Your Single Sign-on has failed because your account is not yet activated.</p>
					<p>Please check your email for an activation invitation before attempting to login using Single Sign-On</p>
				</div>
			)
		}
		if ( currentMode === 'login' && reason === 'invalid_school' )
		{
			return (
				<div key='ssowarning' className='sso-warning'>
				<p>Your Single Sign-on has failed because your school is not enabled for Single Sign-On with Passport.</p>
				<p>Please contact your system administrator.</p>
			</div>
			)
		}
	}

	const shouldShowProvider = () =>
	{
		if ( params.showProvider === false )
		{
			return false ;
		}
		else
		{
			return useProvider ;
		}
	}

	const formElementLogin = () =>
	{
		return (
			<form className='registration-form' onSubmit={handleSubmit(onSubmit)} key='rform'>

				{ infoHeader() }

				<BootstrapRow>
					< FormFragmentLoginInputs authority_id={authority_id} iconColor={params.iconColor} sectionName='login' register={register} formErrors={formErrors} showUsernameInput={true} showPasswordInput={true} showProviderInput={shouldShowProvider()} onClickSaveForm={onClickSaveForm} />

					<BootstrapCol width={12}>
						<button type='submit' key='btnLogin' className='btn btn-primary' id='submitBtn' onClick={onClickSaveForm} style={getLoginButtonStyle()}>Log In</button>
					</BootstrapCol>
				</BootstrapRow>

			</form>
		)
	}

    const forgotPasswordformElement = () =>
    {
		return (
			<Fragment>
				{infoHeader()}
				<form className='registration-form' onSubmit={handleSubmit(onSubmit)} key='rform'>
					<BootstrapRow>

						< FormFragmentLoginInputs authority_id={authority_id} iconColor={params.iconColor} sectionName='login' register={register} formErrors={formErrors} showPasswordInput={false} showProviderInput={shouldShowProvider()}
												  showUsernameInput={true} onClickSaveForm={onClickSaveForm}/>

						<BootstrapCol width={12} style={{marginBottom: '15px'}}>
							<div className='form-group'>
								<button type='button' className='btn btn-primary' id='submitBtn' style={{marginBottom: '-5px'}} onClick={onClickSaveForm}>Reset Password</button>
							</div>
						</BootstrapCol>

						<BootstrapCol width={12}>
							<div className='form-group'>
								<button type='button' className='btn btn-secondary' id='cancelBtn' onClick={onForgotPasswordCancel}>Cancel</button>
							</div>
						</BootstrapCol>
					</BootstrapRow>
				</form>
			</Fragment>
		)
	}

	const registerElement = () =>
	{
		const style = getPanelTextStyle() ;

		const showS360 = params?.suppressSchool360Notes !== true && authority_id !== 'NCL' && +variant_type !== ProviderVariantType.EHCP_SCHOOLS;

		return (
			<form className='form' id='login_form' style={style}>
				<p className='welcome-body'>Please choose a password ( at least 8 letters, including a number and an
					upper-case letter ) and click 'Register' to complete the registration process.</p>
					{ showS360 === true && <p>If your setting uses School360 EYFS, you will get an account created with the same password.</p> }

				< FormFragmentLoginInputs rules={defaultRules} authority_id={authority_id} iconColor={params.iconColor} sectionName='login' register={register} formErrors={formErrors} showPasswordInput={true} showConfirmPassword={true} showUsernameInput={false} showProviderInput={false} onClickSaveForm={onClickSaveForm} />

				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onClickSaveForm}>Register
					</button>
				</div>
			</form>
		)
	}

	const passwordReset = () =>
	{
		return (
			<form className='registration-form' onSubmit={handleSubmit(onSubmit)} autoComplete='off' key='rform'>
				<BootstrapRow>
					<BootstrapCol width={12} style={{marginBottom: '20px'}}>
						<div className='welcome-body' style={{textAlign: 'justify'}}>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Change Password' to complete the process.
						</div>
					</BootstrapCol>

					< FormFragmentLoginInputs rules={defaultRules} authority_id={authority_id} iconColor={params.iconColor} sectionName='login' register={register} formErrors={formErrors} showPasswordInput={true} showConfirmPassword={true} showUsernameInput={false} showProviderInput={false} onClickSaveForm={onClickSaveForm} />

					<BootstrapCol width={12}>
						<div className='form-group'>
							<button type='button' className='btn btn-primary' id='submitBtn' onClick={onClickSaveForm}>Set Password</button>
						</div>
					</BootstrapCol>
				</BootstrapRow>
			</form>
		)
	}

	const pStyle = {textAlign: 'center'} ;

	const registerCompleteElement = ( ) =>
	{
		return <form key='complete' className='form' id='login_form'>
			<p style={{...pStyle, fontSize: 'large'}} key='rc1'>Thank You.</p>
			<p style={pStyle} key='rc2'>The registration process is almost complete.</p>
			<p style={pStyle} key='rc3'>You will now be sent an activation email which will contain a link that you can click to activate your account and log in. Please check your email now for the activation email.</p>
		</form>
	}

	const passwordChangeCompleteElement = () =>
	{
		return (
			<form className='form' id='login_form'>
				<p key='pwc1'>Thank You.</p>
				<p key='pwc2'>Your password has been changed.</p>
			</form>
		)
	}

	const changePasswordformElement = ( requireOldPassword ) =>
    {
		const sectionName = 'login';

		return (
			<form className='form' id='login_form'>
				<p className='welcome-body'>Please choose a new password ( at least 8 letters, including a number and an upper-case letter ) and click 'Change Password' to complete the process.</p>
				{requireOldPassword && <BootstrapCol width={12} style={{marginBottom: '10px'}}>
					<FormInputPassword readOnly={false} placeHolder='Old Password' autocomplete="off"
									   sectionName={sectionName} name={'oldpassword'} register={register} required={true} maxLength={100}
									   formErrors={formErrors}/>
				</BootstrapCol> }
				<BootstrapCol width={12} style={{marginBottom: '10px'}}>
					<FormInputPassword rules={defaultRules} readOnly={false} placeHolder='New Password'
									   sectionName={sectionName} name={'password'} register={register} required={true} maxLength={100}
									   formErrors={formErrors}/>
				</BootstrapCol>
				<BootstrapCol width={12} style={{marginBottom: '10px'}}>
					<FormInputPassword readOnly={false} placeHolder='Confirm Password'
									   sectionName={sectionName} name={'password1'} register={register} required={true} maxLength={100}
									   formErrors={formErrors}/>
				</BootstrapCol>
				<div className='form-group'>
					<button type='button' className='btn btn-primary' id='submitBtn' onClick={onClickSaveForm}>Change Password</button>
				</div>
				{ currentMode === 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onLogout}>Logout</button>
				</div> }
				{ currentMode !== 'change_password_first' && <div className='form-group'>
					<button type='button' className='btn btn-primary' id='logoutBtn' onClick={onChangePasswordCancel}>Cancel</button>
				</div> }
			</form>
		)
    }

	const onClosePrivacyModal = () =>
	{
		doLoginFunctions( user );
	};

	const privacyStatementElement = () =>
	{
		return (
			<Modal key='privacyModal' center={true} open={dialogPrivacyOpen} closeOnOverlayClick={false} focusTrapped={false} showCloseIcon={false} onClose={onClosePrivacyModal}>
				<ModalPrivacyStatement authority_id={authority_id} onClose={onClosePrivacyModal}/>
			</Modal>
		)
	}

	const forgotPasswordLink = () =>
	{
		// const privacy_href = authority_id === 'NCL' ? 'https://passport.gateshead.gov.uk/NCC_Privacy_Statement_v1.2.pdf' : '/School_Readiness_Passport_Privacy_Notice_1.0.pdf' ;

		const privacy_href = params.privacyDoc ;

		return (
			<div className='login_footer'>
				<div><a className='black_text' href='#' onClick={onForgotPassword}>Forgot Password</a></div>
				<div><a className='black_text' href={privacy_href} target='_blank'>Privacy Statement</a></div>
			</div>
		)
	}

	const newUserRegistrationElement = () =>
	{
		return (
			<LoginNewUserRegistrationForm ref={newUserForm} />
		)
	}

	const formBody = () =>
	{
		switch ( currentMode )
		{
			case 'login':
			case 'activate':
			case 'password_reset_complete' :
				return (
					<Fragment>
						{ /* formElement() */ }
						{ formElementLogin() /* NEW VERSION OF LOGIN FORM USING REACT-HOOK-FORM Not yet working */ }
						{ forgotPasswordLink() }
						{ /* newToChildmindingLink() */}
					</Fragment>
				)
			case 'forgot_password':
				return forgotPasswordformElement() ;
			case 'change_password':
				return changePasswordformElement(true) ;
			case 'change_password_first':
				return changePasswordformElement(false) ;
			case 'register' :
				return registerElement() ;
			case 'password_reset':
				return passwordReset() ;
			case 'register_complete':
				return registerCompleteElement() ;
			case 'password_changed':
				return passwordChangeCompleteElement() ;
			case 'privacy_statement':
				return privacyStatementElement() ;
			case 'new_user_registration':
				return newUserRegistrationElement() ;
		}
	}

	const getStyle = () =>
	{
		let style = {} ;

		if ( params?.backgroundColor !== undefined )
		{
			style.backgroundColor = params.backgroundColor;
		}
		else if ( params?.background !== undefined )
		{
			style.background = params.background;
		}
		else if ( params?.backgroundImage !== undefined )
		{
			style.backgroundImage = 'url(' + params.backgroundImage + ')' ;
		}

		return style ;
	}

	const getPanelStyle = () =>
	{
		let style = {} ;

		if ( params?.panelBackgroundColor !== undefined )
		{
			style.backgroundColor = params.panelBackgroundColor;
		}
		else
		{
			if ( params?.panelBackground !== undefined )
			{
				style.background = params.panelBackground;
			}

		}

		return style ;
	}

	const getPanelTextStyle = () =>
	{
		if ( params.panelTextColor !== undefined )
		{
			return { color:  params.panelTextColor }
		}
		else
		{
			return {} ;
		}
	}

	const getLoginButtonStyle = () =>
	{
		let style = {} ;

		if ( params?.loginButtonStyle !== undefined )
		{
			const base = { width: '100%' } ;
			style = { ...base, ...params.loginButtonStyle } ;
		}
		else
		{
			style = { width: '100%' };
		}

		return style ;
	}

    const getMessage = () =>
    {
        const styl = {
            textAlign: 'center',
            color: 'red',
            fontSize: 'initial'
        }

		let logoutMessage ;

		if ( logoutreason === undefined )
		{
			logoutMessage = null ;
		}
		else if ( logoutreason === 'invalid_token' )
		{
			logoutMessage = <div style={styl}>Invalid Authentication Token</div>
		}
		else
		{
			logoutMessage = <div style={styl}>Logged out due to inactivity</div>
		}

        return logoutMessage ;

    }
	const loginPage = () =>
	{
		const className = params.loginContentWrapperClass === undefined ? "login-content-wrapper login" : "login-content-wrapper " + params.loginContentWrapperClass + " login" ;

		return (
			<div className={className}  style={getStyle()}>
				<div className='login-container login'>
					<div className='container-inner login' style={getPanelStyle()}>
						{ suppressLogo !== true && logo ( defaultLogo )}
						{ getTitle(title) }
                        { getMessage() }
						{ formBody() }
					</div>
				</div>
			</div>
		)
	}

	const registrationPage = () =>
	{
		return (
			<div className="login-content-wrapper registration">
				<div className='login-container registration'>
					<div className='container-inner registration'>
						{ logo ( defaultLogo )}
						{ getTitle(title) }
						{ formBody() }
					</div>
				</div>
			</div>
		)
	}

	const postRegistrationPage = () =>
	{
		return (
			<div className="login-content-wrapper complete">
				<div className='login-container registration'>
					<div className='container-inner registration'>
						{formBody()}
					</div>
				</div>
			</div>
		)
	}

	switch (currentMode)
	{
		case 'new_user_registration':
			return registrationPage();
		case 'register_complete':
		case 'privacy_statement':
			return postRegistrationPage();
		default:
			return loginPage();
	}
}

export default LoginForm;
